import { loadable } from 'utils';

export const Create = loadable(() => import('./Create'), {});
